export const formatNumberToLocale = (number: number) =>
  number.toLocaleString('en-US');

export const formatNumber = (number: number): string => {
  let formattedNumber = number.toString();

  if (number >= 10000) {
    formattedNumber =
      formatNumberToLocale(Number((number / 1000).toFixed(0))) + 'K';
  } else if (number >= 1000) {
    formattedNumber =
      formatNumberToLocale(Number((number / 1000).toFixed(1))) + 'K';
  } else {
    formattedNumber = formatNumberToLocale(number);
  }

  return formattedNumber;
};

export const getRandomInt = (max: number) => Math.floor(Math.random() * max);

export const isNumber = (value: unknown): value is number => {
  return typeof value === 'number' && !Number.isNaN(value);
};
